<template>
    <div class="flex mt-4 flex-wrap md:flex-nowrap pb-10 sm:pb-0 md:pb-0 md:mb-6">
        <form-values
            class="xl:w-2/5 lg:w-2/5 md:w-80 w-full pb-5"
            wrapper-max-height="380px"
            form-height="calc(100vh - 350px)"
            :form="form"
            @go-back="$emit('go-back')"
            @input="form[$event.type] = $event.value"
        >
            <template slot="goal">
                <jet-label class="text-gray-800" for="goal" value="Finalidade"/>
                <jet-auto-complete
                    id="goal"
                    class="mt-1 block w-full "
                    v-model="form.goal"
                    :placeHolder="'Selecione uma das opções'"
                    :options-list="$page.props.goal_list"
                    />
                <jet-input-error :message="form.error('goal')" class="mt-2"/>
            </template>
        </form-values>

        <form-summary
            class="flex-1 sm:mb-6 md:mb-0 flex flex-col justify-evenly"
            :form="form"
            :favored="favoredFormatted"
            @input="form[$event.type] = $event.value"
            @submit="transferTed"
        />
    </div>
</template>

<script>
import JetInput from "../../../Jetstream/Input.vue";
import JetAutoComplete from "../../../Jetstream/AutoComplete.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import JetDecimal from "../../../Jetstream/Decimal.vue";
import JetLabel from "../../../Jetstream/Label.vue";
import JetTextarea from "../../../Jetstream/Textarea.vue";
import JetDatePicker from "../../../Jetstream/DatePicker.vue";
import TitleSection from '../components/TitleSection.vue';
import FormValues from "../components/FormValues.vue";
import FormSummary from "../components/FormSummary.vue";

export default {
    name: 'FormValueDetails',
    props: {
        favored: { type: Object, required: true}
    },
    data(){
        return {
            datePix: new Date(),
            form: this.$inertia.form({
                _method: 'POST',
                amount: 0,
                contact: {
                    name: this.favored.name,
                    federal_document: this.favored.federal_document,
                },
                transfer_type: {
                    name: 'Entre contas'
                },
                selected_account: {
                    agency: this.favored.accountSelected.agency,
                    bank: {
                        id: this.favored.accountSelected.bank.id,
                        name: this.favored.accountSelected.bank.name
                    },
                    number: this.favored.accountSelected.number,
                    key: null,
                    type: this.favored.accountSelected.type
                },
                federal_document: null,
                goal: {},
                google_code: null,
                receiver_code: null,
                description: null
            })
        }
    },
    computed: {
        favoredFormatted(){
            return {
                ...this.favored,
                bank: {
                    description: this.favored.accountSelected.bank.name
                },
                account: {
                    agency: this.favored.accountSelected.agency,
                    account: this.favored.accountSelected.number
                }
            }
        }
    },
    methods: {
        toggleScroll(){
            document.getElementById('form-values').classList.toggle('md:overflow-y-auto')
        },
        handleScroll(removeOrAddEvent){
            const input = document.querySelector('.vs__search')
            input && input[removeOrAddEvent]('focus', this.toggleScroll)
            input && input[removeOrAddEvent]('blur', this.toggleScroll)
        },
        transferTed(){
            const amount = this.form.amount.replace(',', '.')
            if (parseFloat(amount) === 0) {
                this.callToast('Informe o valor da operação.', 'error');
                return;
            } else if (!this.form.google_code){
                this.callToast('Informe o código de autorização.', 'error');
                return;
            }else if(!this.form.goal.id){
                this.callToast('Selecione uma finalidade.', 'error');
                return
            }

            this.form.post('/transfer', {
                onError: () => {
                    this.form.processing = false
                },
            })
        },
        callToast(msg, type, temp = 5000) {
            this.$toast.open({
                message: msg,
                type: type,
                duration: temp,
                position: 'top-right'
            });
        }
    },
    mounted(){
        this.handleScroll('addEventListener')
    },
    destroyed(){
        this.handleScroll('removeEventListener')
    },
    components: {
        JetInput,
        JetDecimal,
        JetLabel,
        JetTextarea,
        JetAutoComplete,
        JetDatePicker,
        JetInputError,
        TitleSection,
        FormValues,
        FormSummary
    }
}
</script>
